import React, { Component } from 'react';
import { Button, Card, CardHeader, CardBody, CardFooter, Col, Container, Form, FormGroup, Label, Input, InputGroup, InputGroupAddon, InputGroupText, Row, NavLink, FormFeedback   } from 'reactstrap';
import LoadingOverlay from 'react-loading-overlay';

import CRNote from '../../Common/crNote'
import PageHead from '../../Common/pageHead'
import Menu from '../../Common/menu'

import Api from '../../../api'

class Registration extends Component {
  constructor(props) {
    super(props)
    this.state = {
      email: '',
      pwd: '',
      controller: '',
      phone: '',
      fname: '',
      lname: '',
      msg: '',
      over: false,
    }
  }

  register() {
    var key = "t_" + this.state.phone;
    this.setState({msg:'Checking.... Step 1'})
    var api = new Api()
    api.get(key, (succ, data) => {
      var t = 1;
      if(succ && data["val"]) {
        t = data["val"] + 1;
      }

      if(t <= 5) {
        api.set(key, t, (succ, data) => {});

        api.checkDevice(this.state.phone, 2, (succ, err) => {
              if(succ) {
                if(err.val.toLowerCase().indexOf("off") != -1) {
                  this.setState({msg:'Checking.... Step 2'});
                  api.checkDevice(this.state.phone, 3, (succ, err) => {
                    if(succ) {
                      if(err.val.toLowerCase().indexOf("on") != -1 && err.val.toLowerCase().indexOf("number set") != -1) {
                        api.register(this.state.email, this.state.pwd, this.state.email, 
                          this.state.phone, this.state.fname, this.state.lname, (succ, data) => {
                          this.setState({msg:''})
                          if(succ) {
                            alert("You have successfully registered!!");
                            api.jump("login");
                          } else {
                            alert(err);
                          }
                        });
                      } else {
                        this.setState({msg:''})
                        if(err.val.toLowerCase().indexOf("number set") != -1) {
                          alert("Please turn on emergency mode at SOS Setting>SOS mode setting>On>OK.");
                        } else {
                          alert("Please setup your emergency contact number at SOS Setting>SOS numbers.");
                        }
                      }
                    } else {
                      this.setState({msg:''})
                      alert(err);
                    }
                  })
                } else {
                  this.setState({msg:''})
                  alert("Please make sure you are using VOCA V330 or V530 cell phone. If you are, please turn off DND at Settings>DND>Off>OK.");
                }
              } else {
                this.setState({msg:''})
                if(err == null) { 
                  alert("Please make sure you are using VOCA V330 or V530 cell phone. If you are, please turn off DND at Settings>DND>Off>OK.");
                } else {
                  alert(err);
                }
              }
            });
      } else {
        this.setState({over: true, msg: ""});
      }
    });

return;
      // api.checkDevice(this.state.phone, 1, (succ, err) => {
        // if(succ) {
        //     this.setState({msg:'Checking.... Step 2'});
            // caches.set(, val, callback);
            
          
        // } else {
        //   this.setState({msg:''})
        //   if(err == null) {
        //     alert("Your phone is not V530 or V330 with the latest software version. Please contact us.");
        //   } else {
        //     alert(err);
        //   }
        // }
      // });
    // this.setState({msg:'Checking.... checking phone number is installed in V530 mobile phone.'})
    // var api = new Api()
    // // api.set(this.state.phone, (succ, data) => {
    // //   console.log(succ)
    // //   console.log(data)

    //   fetch("https://do9u0cp32e.execute-api.us-west-2.amazonaws.com/default/check_phone_state?p=" + encodeURIComponent(this.state.phone))
    //   .then(() => { 
    //     console.log("XXXXXX")
    //     api.delay(20, () => {
    //         api.get(this.state.phone, (succ, data) => {
    //           console.log(succ)
    //           console.log(data)
    //           if(data["val"].trim().length == 0) {
    //             this.setState({msg:'You dont have V530 mobile phone.'})
    //           } else {
    //             api.register(this.state.email, this.state.pwd, this.state.email, 
    //                   this.state.phone, this.state.fname, this.state.lname, (succ, data) => {
    //                     if(succ) {
    //                       this.setState({msg:'Successful'})
    //                     } else {
    //                       this.setState({msg:data})
    //                     }
    //                   })
    //           }
    //         })
    //       })
    //   },
    //     (error) => {
    //     console.log("======")
    //       api.delay(20, () => {
    //         api.get(this.state.phone, (succ, data) => {
    //           console.log(succ)
    //           console.log(data)
    //           if(data["val"].trim().length == 0) {
    //             this.setState({msg:'You dont have V530 mobile phone.'})
    //           } else {
    //             api.register(this.state.email, this.state.pwd, this.state.email, 
    //                   this.state.phone, this.state.fname, this.state.lname, (succ, data) => {
    //                     if(succ) {
    //                       this.setState({msg:'Successful'})
    //                     } else {
    //                       this.setState({msg:data})
    //                     }
    //                   })
    //           }
    //         })
    //       })
    //     })
      // .then(res => res.json())
      // .then(
      //   (result) => {
      //     api.delay(1, () => {
      //       api.get(this.state.phone, (succ, data) => {
      //         console.log(succ)
      //         console.log(data)
      //       })
      //     })
      //   },
      //   (error) => {
      //     this.setState({msg:'Service is temporarily unavailable, please try again later.'})
      //   }
      // )
    // })
    // api.register(this.state.email, this.state.pwd, this.state.controller, 
    //   this.state.phone, this.state.fname, this.state.lname, (succ, data) => {
    //     if(succ) {
    //       this.setState({msg:'Successful'})
    //     } else {
    //       this.setState({msg:data})
    //     }
    //   })
  }

  render() {
    return (
      <LoadingOverlay
        active={this.state.msg.length > 0}
        spinner
        text={this.state.msg}
        >
      <div className="app align-items-center mcg">

        <span className="frontbk" style={{zIndex:"0"}} />

        <Container style={{zIndex:"1"}}>
          <PageHead/>
        </Container>

        <Container style={{zIndex:"2"}}>
          <Row className="justify-content-center">
            <Card className="mb-0">
              <Menu/>

              <CardHeader  className="titlehead">
                  <h1 className="mb-0 my-2">Registrater</h1>
                  <p className="text-center mb-0">Please fill out all fields then click Register.</p>
              </CardHeader>

              <CardBody className="pageSetting login-form py-0">
                <Row>
                  <Col lg="12" className="leftbox">
                    <div className="rb-inner">
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="icon-user" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input type="text" placeholder="Firstname*" autoComplete="firstname" onChange={(evt) => { this.setState({fname: evt.target.value}); }} required/>
                        <Input type="text" placeholder="Lastname*" autoComplete="lastname" onChange={(evt) => { this.setState({lname: evt.target.value}); }} required/>
                        <FormFeedback className="help-block">Please provide a valid information</FormFeedback>
                      </InputGroup>
                      <div className="wraning-msg">
                        {/* Warning message for LoginID */}
                      </div>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="fa fa-phone" />
                        </InputGroupText>
                        </InputGroupAddon>
                        <Input type="phone" placeholder="Phone Number* [Format : +{country code}{phone number}]" autoComplete="cell" onChange={(evt) => { this.setState({phone: evt.target.value}); }} required/>
                      </InputGroup>
                      <div className="wraning-msg">
                        {/* Warning message for LoginID */}
                      </div>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="icon-envelope" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input type="text" placeholder="Email Address*" autoComplete="emailaddress" onChange={(evt) => { this.setState({email: evt.target.value}); }} required/>
                        <FormFeedback className="help-block">Please provide a valid information</FormFeedback>
                      </InputGroup>
                      <div className="wraning-msg">
                        {/* Warning message for LoginID */}
                      </div>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="fa fa-key" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input type="password" placeholder="Password*" autoComplete="" onChange={(evt) => { this.setState({pwd: evt.target.value}); }} required/>
                        <Input type="password" placeholder="Confirm Password*" autoComplete="" onChange={(evt) => { this.setState({pwd: evt.target.value}); }} required/>
                        <FormFeedback className="help-block">Please provide a valid information</FormFeedback>
                      </InputGroup>
                      <div className="wraning-msg">
                        {/* Warning message for LoginID */}
                      </div>
                      {/*
                        <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="icon-envelope" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input type="text" placeholder="Alexa Email Address*" autoComplete="emailaddress" onChange={(evt) => { this.setState({controller: evt.target.value}); }} required/>
                        <FormFeedback className="help-block">Please provide a valid information</FormFeedback>
                      </InputGroup>
                      */}
                      <div className="wraning-msg">
                        {/* Warning message for LoginID */}
                        {this.state.msg}
                      </div>

                      <div className="registerbox mb-2">
                        By clicking "Register" I agree that:
                        <ol className="terms">
                          <li>I have read and accepted the Ask My Phone <NavLink className="inline-link" href="/toc">Terms of Service</NavLink>.</li>
                          <li>I have read and accepted the Ask My Phone <NavLink className="inline-link" href="/pp">Privacy Policy</NavLink>.</li>
                          <li>I understand that I need to set up other devices properly in order for this service to work.</li>
                          <li>I understand that I need to test this service and all components it required from time to time to make sure everything works.</li>
                          <li>I have asked and received permissions from the individuals I will enter as Emergency Contacts for www.askmyphone.net to send SMS and call them.</li>
                          <li>I understand that my phones will incur charges for sending out and receiving SMS if there are any in order to enjoy services provided by www.askmyphone.net.</li>
                        </ol>
                      </div>

                      <div className="text-center">
                        { !this.state.over && <Button color="primary" className="my-3 px-4 btn-brand" onClick={this.register.bind(this)}>Register Now</Button> }
                        {/* <NavLink href="/#/login" ><Button outline  className="px-4 btn-outline" color="primary">Back</Button></NavLink>  */}
                        { this.state.over && <p><b>You failed to register for too many times, please contact us at support@askmyphone.net for assistance. Thanks You!!</b></p> }
                      </div>

                    </div>
                  </Col>

                  {/*
<Col lg="4" className="rightbox termsbox rb-flex">
                    
                    <div className="tips-msg">
                      <div className="stitle text-center">Note:</div>
                      Note: For International Phone numbers, enter International Country code first, <NavLink href="#" className="inline-link">Click Here for Examples</NavLink>.<br /><br /> 
                      Example showing UK: <br/>change this 07911 123456 to 447911123456
                    </div>

                    <div className="tips-msg pb-2" style={{ borderTop: '1px solid #ddd' }}>
                      <div className="stitle text-center">remainder:</div>
                      Upon successful registration please check your email or spam folder for a welcome email with instructions from us. 
                    </div>
                  </Col>
                  */}
                </Row>
              </CardBody>

            </Card>
          </Row>
        </Container>

        <Container style={{zIndex:"3"}}>
          <CRNote/>
        </Container>
      </div>
      </LoadingOverlay>
    );
  }
}

export default Registration;



// WEBPACK FOOTER //
// ./src/views/Pages/Register/Register.js